import React from "react";
import styles from './intro.module.css';



const IntroBox = () =>{
  return (
    <>
      <div className={styles.overlayIntro}></div>
      <div className={styles.containerIntro}>
        <div className={styles.layout}>
          <div className={styles.contentBox}>
            <div className={styles.intro_main}>

            <h1>About Mento</h1>
            <p>
              At Mento, we are dedicated to providing professional counseling and emotional support to individuals seeking to enhance their mental well-being. Our team comprises certified counselors and mental health professionals committed to offering personalized care through online mental health services.
            </p>
            
            
            <p>
We aim to make mental wellness support accessible and affordable. By leveraging virtual mental health counseling, we ensure that you can connect with the best therapists in India from the comfort of your home.
            </p>

            </div>
          </div>
          <div className={styles.shapesColumn}>
            <div className={styles.recBottomRight}></div>
            <div className={styles.squareUpperRight}></div>
            <div className={styles.recUpperLeft}></div>
            <div className={styles.squareBottomLeft}></div>
          </div>
        </div>
      </div>
    </>
  )

}
export default IntroBox;